// extracted by mini-css-extract-plugin
module.exports = {"LiveNewsFeed":"LiveNewsFeed_LiveNewsFeed__389QF","title":"LiveNewsFeed_title__2o5_r"};